// src/components/management/AITalentAssistantDashboard.jsx
import React, { useMemo } from 'react';
import { AlertTriangle, Users, ShieldCheck } from 'lucide-react';
import { analyzeTeamHealth } from '../../services/aiAnalysisService';

const AITalentAssistantDashboard = ({ userProfiles }) => {
  const analysisResult = useMemo(() => {
    if (!userProfiles) return { alerts: [], successionPlans: [] };
    return analyzeTeamHealth(userProfiles);
  }, [userProfiles]);

  const AlertCard = ({ alert }) => {
    const severityStyles = {
      warning: {
        icon: <AlertTriangle className="w-6 h-6 text-yellow-500" />,
        borderColor: 'border-yellow-500',
        bgColor: 'bg-yellow-50',
      },
      critical: {
        icon: <AlertTriangle className="w-6 h-6 text-red-500" />,
        borderColor: 'border-red-500',
        bgColor: 'bg-red-50',
      },
    };
    const style = severityStyles[alert.type] || severityStyles.warning;

    return (
      <div className={`p-4 rounded-lg border-l-4 ${style.borderColor} ${style.bgColor}`}>
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">{style.icon}</div>
          <div>
            <h4 className="font-bold text-gray-800">{alert.title} for {alert.userName}</h4>
            <p className="text-sm text-gray-700 mt-1">{alert.message}</p>
            <p className="text-sm text-blue-700 font-medium mt-2 bg-blue-100 p-2 rounded-lg">
              推奨アクション: {alert.recommendation}
            </p>
          </div>
        </div>
      </div>
    );
  };
  
  const PlanCard = ({ plan }) => (
    <div className="p-4 rounded-lg border-l-4 border-blue-500 bg-blue-50">
      <h4 className="font-bold text-gray-800 flex items-center gap-2"><Users className="w-5 h-5 text-blue-600"/>{plan.title}</h4>
      <p className="text-sm text-gray-700 mt-1">{plan.message}</p>
      <p className="text-sm text-green-700 font-medium mt-2 bg-green-100 p-2 rounded-lg">
        推奨アクション: {plan.recommendation}
      </p>
    </div>
  );

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <ShieldCheck className="w-6 h-6 text-indigo-600"/>
            AIタレントマネジメント・アシスタント
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h4 className="font-semibold text-gray-700">プロアクティブ・アラート</h4>
            {analysisResult.alerts.length > 0 ? (
              analysisResult.alerts.map((alert, index) => <AlertCard key={index} alert={alert} />)
            ) : (
              <p className="text-sm text-gray-500 p-4 bg-gray-50 rounded-lg">現在、緊急のアラートはありません。チームは健全な状態です。</p>
            )}
          </div>
          <div className="space-y-4">
            <h4 className="font-semibold text-gray-700">サクセッションプランニング支援</h4>
            {analysisResult.successionPlans.length > 0 ? (
                analysisResult.successionPlans.map((plan, index) => <PlanCard key={index} plan={plan} />)
            ) : (
                 <p className="text-sm text-gray-500 p-4 bg-gray-50 rounded-lg">チームのスキルカバレッジは良好です。</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AITalentAssistantDashboard;
